// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ActualsPlantPerformanceSummary {
  readonly id: string;
  readonly name: string;
  readonly marketId: string;
  readonly divisionId: string | null;
  readonly status: Enums.ActualsPerformanceStatus;
  readonly budget: string | null;
  readonly budgetUnit: Enums.Unit;
  readonly capacity: string | null;
  readonly capacityUnit: Enums.Unit;
  readonly productCategory: Enums.ProductCategory[];
  readonly varianceMix: string | null;
  readonly varianceAsphalt: string | null;
  readonly varianceAggregate: string | null;
  readonly actualVolumeMix: string | null;
  readonly actualVolumeAsphalt: string | null;
  readonly actualVolumeAggregate: string | null;
  readonly quotedVolumeMix: string | null;
  readonly quotedVolumeAsphalt: string | null;
  readonly quotedVolumeAggregate: string | null;
  readonly backlogVolumeMix: string | null;
  readonly backlogVolumeAsphalt: string | null;
  readonly backlogVolumeAggregate: string | null;
  readonly plannedVolumeMix: string | null;
  readonly plannedVolumeAsphalt: string | null;
  readonly plannedVolumeAggregate: string | null;
  readonly plannedActualPercentageMix: string | null;
  readonly plannedActualPercentageAsphalt: string | null;
  readonly plannedActualPercentageAggregate: string | null;
  readonly budgetUtilizationPercentageMix: string | null;
  readonly budgetUtilizationPercentageAggregate: string | null;
  readonly budgetUtilizationPercentageAsphalt: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.status = data.status === undefined ? Enums.ActualsPerformanceStatus.AtRisk : data.status;
    this.budget = data.budget === undefined ? null : data.budget;
    this.budgetUnit = data.budgetUnit === undefined ? Enums.Unit.Ac : data.budgetUnit;
    this.capacity = data.capacity === undefined ? null : data.capacity;
    this.capacityUnit = data.capacityUnit === undefined ? Enums.Unit.Ac : data.capacityUnit;
    this.productCategory = (data.productCategory ?? []).map((productCategory: any) =>
      productCategory === undefined ? Enums.ProductCategory.ReadyMix : productCategory,
    );
    this.varianceMix = data.varianceMix === undefined ? null : data.varianceMix;
    this.varianceAsphalt = data.varianceAsphalt === undefined ? null : data.varianceAsphalt;
    this.varianceAggregate = data.varianceAggregate === undefined ? null : data.varianceAggregate;
    this.actualVolumeMix = data.actualVolumeMix === undefined ? null : data.actualVolumeMix;
    this.actualVolumeAsphalt =
      data.actualVolumeAsphalt === undefined ? null : data.actualVolumeAsphalt;
    this.actualVolumeAggregate =
      data.actualVolumeAggregate === undefined ? null : data.actualVolumeAggregate;
    this.quotedVolumeMix = data.quotedVolumeMix === undefined ? null : data.quotedVolumeMix;
    this.quotedVolumeAsphalt =
      data.quotedVolumeAsphalt === undefined ? null : data.quotedVolumeAsphalt;
    this.quotedVolumeAggregate =
      data.quotedVolumeAggregate === undefined ? null : data.quotedVolumeAggregate;
    this.backlogVolumeMix = data.backlogVolumeMix === undefined ? null : data.backlogVolumeMix;
    this.backlogVolumeAsphalt =
      data.backlogVolumeAsphalt === undefined ? null : data.backlogVolumeAsphalt;
    this.backlogVolumeAggregate =
      data.backlogVolumeAggregate === undefined ? null : data.backlogVolumeAggregate;
    this.plannedVolumeMix = data.plannedVolumeMix === undefined ? null : data.plannedVolumeMix;
    this.plannedVolumeAsphalt =
      data.plannedVolumeAsphalt === undefined ? null : data.plannedVolumeAsphalt;
    this.plannedVolumeAggregate =
      data.plannedVolumeAggregate === undefined ? null : data.plannedVolumeAggregate;
    this.plannedActualPercentageMix =
      data.plannedActualPercentageMix === undefined ? null : data.plannedActualPercentageMix;
    this.plannedActualPercentageAsphalt =
      data.plannedActualPercentageAsphalt === undefined
        ? null
        : data.plannedActualPercentageAsphalt;
    this.plannedActualPercentageAggregate =
      data.plannedActualPercentageAggregate === undefined
        ? null
        : data.plannedActualPercentageAggregate;
    this.budgetUtilizationPercentageMix =
      data.budgetUtilizationPercentageMix === undefined
        ? null
        : data.budgetUtilizationPercentageMix;
    this.budgetUtilizationPercentageAggregate =
      data.budgetUtilizationPercentageAggregate === undefined
        ? null
        : data.budgetUtilizationPercentageAggregate;
    this.budgetUtilizationPercentageAsphalt =
      data.budgetUtilizationPercentageAsphalt === undefined
        ? null
        : data.budgetUtilizationPercentageAsphalt;
  }

  static zero(): ActualsPlantPerformanceSummary {
    const zeroValues: ExcludeMethodsDeep<ActualsPlantPerformanceSummary> = {
      id: NIL_UUID,
      name: '',
      marketId: NIL_UUID,
      divisionId: null,
      status: Enums.ActualsPerformanceStatus.AtRisk,
      budget: null,
      budgetUnit: Enums.Unit.Ac,
      capacity: null,
      capacityUnit: Enums.Unit.Ac,
      productCategory: [],
      varianceMix: null,
      varianceAsphalt: null,
      varianceAggregate: null,
      actualVolumeMix: null,
      actualVolumeAsphalt: null,
      actualVolumeAggregate: null,
      quotedVolumeMix: null,
      quotedVolumeAsphalt: null,
      quotedVolumeAggregate: null,
      backlogVolumeMix: null,
      backlogVolumeAsphalt: null,
      backlogVolumeAggregate: null,
      plannedVolumeMix: null,
      plannedVolumeAsphalt: null,
      plannedVolumeAggregate: null,
      plannedActualPercentageMix: null,
      plannedActualPercentageAsphalt: null,
      plannedActualPercentageAggregate: null,
      budgetUtilizationPercentageMix: null,
      budgetUtilizationPercentageAggregate: null,
      budgetUtilizationPercentageAsphalt: null,
    };
    return new ActualsPlantPerformanceSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsPlantPerformanceSummaryWireFormat = {
  id: string;
  name: string;
  marketId: string;
  divisionId: string | null;
  status: string;
  budget: string | null;
  budgetUnit: string;
  capacity: string | null;
  capacityUnit: string;
  productCategory: string[];
  varianceMix: string | null;
  varianceAsphalt: string | null;
  varianceAggregate: string | null;
  actualVolumeMix: string | null;
  actualVolumeAsphalt: string | null;
  actualVolumeAggregate: string | null;
  quotedVolumeMix: string | null;
  quotedVolumeAsphalt: string | null;
  quotedVolumeAggregate: string | null;
  backlogVolumeMix: string | null;
  backlogVolumeAsphalt: string | null;
  backlogVolumeAggregate: string | null;
  plannedVolumeMix: string | null;
  plannedVolumeAsphalt: string | null;
  plannedVolumeAggregate: string | null;
  plannedActualPercentageMix: string | null;
  plannedActualPercentageAsphalt: string | null;
  plannedActualPercentageAggregate: string | null;
  budgetUtilizationPercentageMix: string | null;
  budgetUtilizationPercentageAggregate: string | null;
  budgetUtilizationPercentageAsphalt: string | null;
};

type NewActualsPlantPerformanceSummaryProps = PartialDeep<
  ActualsPlantPerformanceSummary,
  { recurseIntoArrays: true }
>;
export const NewActualsPlantPerformanceSummary: (
  props: NewActualsPlantPerformanceSummaryProps,
) => ActualsPlantPerformanceSummary = (props) => new ActualsPlantPerformanceSummary(props);

type NewActualsPlantPerformanceSummaryFromWireFormatProps = PartialDeep<
  ActualsPlantPerformanceSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsPlantPerformanceSummaryFromWireFormat: (
  props: NewActualsPlantPerformanceSummaryFromWireFormatProps,
) => ActualsPlantPerformanceSummary = (props) => new ActualsPlantPerformanceSummary(props);
